export default __webpack_public_path__ + "static/media/PenUser.4c5b3919.png";